// lib/utils.ts
export function getImageUrl(path: string | null | undefined): string | undefined {
  if (!path) return undefined;
  // If already absolute URL, return as is
  if (path.startsWith('http://') || path.startsWith('https://')) {
    return path;
  }
  // Otherwise prefix with backend URL
  const baseUrl = process.env.NEXT_PUBLIC_BACKEND_URL || 'http://localhost:3100';
  const normalizedPath = path.startsWith('/') ? path : `/${path}`;
  return `${baseUrl}${normalizedPath}`;
}